<template>
  <div class="congrats-component" ref="congrat" :class="{'_show': show}">
    <div class="bg"></div>
    <!--<video muted="true" autoplay id="myVideo">-->
    <!--<source src="https://s3.amazonaws.com/canadian-visa-media/agent-sales/Fireworks.mp4" type="video/mp4">-->
    <!--</video>-->
    <div class="content">
<!--      <div class="modal-title">-->
<!--        Sale-->
<!--      </div>-->
        <div class="name">
            <img class="agent-avatar"  :src="getAvatar(users_full_name)">
            {{ users_full_name }}
        </div>
      <div class="congratulations-img"></div>
      <div class="amount">
        {{ amount | numFormat('$') }}
      </div>
      <div class="product">
        {{ product }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { find } from "lodash";

export default {
  name: "Congratulation",
  props: ["data"],
  data() {
    return {
      users_full_name: "",
      amount: 0,
      product: "",
      show: false,
    };
  },
    computed: {
        ...mapGetters(["streams"]),
    },
  methods: {
    open(data) {
      this.users_full_name = data.users_full_name;
      this.amount = data.amount;
      this.product = data.product;
      // this.show();
      this.show = true;
      setTimeout(() => {
        this.show = false
      }, 14000);
    },

      getAvatar(name) {
        const users = this?.streams?.streams?.statistic?.users || [];

        const user = find(users, {full_name: name});

        if (user && user.logo_avatar) {
            return user.logo_avatar || '';
        } else {
          let baseUrl = "https://d1ac9zce9817ms.cloudfront.net/images/icons";

          let number = parseInt(
              String(
                  String(name)
                      .split("")
                      .map((s) => s.charCodeAt(0))
                      .reduce((a, b) => a + b, 0) % 15
              ),
              10
          );

          return baseUrl + String(number) + ".svg";
        }
    },
  },
};
</script>


<style lang="scss">
.congrats-component {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  visibility: hidden;
  z-index: 100;
  transform: translateY(-100%);
  transition: transform 0.4s ease-in 0s, visibility 0s linear 0.5s;
  &._show {
    visibility: visible;
    transform: translateY(0%);
    transition: transform 0.4s ease-out 0s;
  }
  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: url("https://s3.amazonaws.com/canadian-visa-media/agent-sales/congrats.gif");
      background-repeat: repeat;
      background-size: cover;
      filter: blur(4px);
    }
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #0004;
    }
  }
  .congratulations-img {
    width: 814px;
    height: 235px;
    background-image: url("https://s3.amazonaws.com/canadian-visa-media/agent-sales/congrant.png");
    background-repeat: repeat;
    background-size: contain;
    margin: 0 0 60px;
  }
  .content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  .modal-title {
    line-height: 1;
    font-size: 80px;
    color: white;
    animation: scale 2s infinite alternate;
    font-weight: 600;
    // text-shadow: 0px 0px 1px #0004;
  }
  .name {
    line-height: 1;
    font-size: 76px;
    color: white;
    animation: scale 2s infinite alternate;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 10px;
      margin-bottom: 25px;
    // text-shadow: 0px 0px 1px #0004;
      .agent-avatar{
          max-width: 150px;
          height: 150px;
      }
  }
  .amount {
    font-size: 90px;
    line-height: 1;
    color: #75ba2e;
    font-weight: 700;
    animation: leaves 2s infinite alternate;
    text-rendering: optimizeLegibility;
    // text-shadow: 0px 0px 1px #0008;
  }
  .product {
    margin-top: 90px;
    font-size: 36px;
    line-height: 1;
    font-weight: 700;
    opacity: 0.6;
    // text-shadow: 0px 0px 1px #0008;
    animation: scale 2s infinite 1s alternate;
  }
}
@keyframes scale {
  0% {
    transform: matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1);
  }
  100% {
    // scale(1.3)
    transform: matrix3d(1.3,0,0.00,0,0.00,1.3,0.00,0,0,0,1,0,0,0,0,1);
  }
}

@keyframes leaves {
  0% {
    // scale (2.65)
    transform: matrix3d(2.65,0,0.00,0,0.00,2.65,0.00,0,0,0,1,0,0,0,0,1);
    color: #75ba2e;
  }
  100% {
    transform: matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1);
    color: white;
  }
}
</style>
